document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }

  window.mz.getFirstThreeWords = function (str) {
    var stripHtml = function(value) {
      if (!value) {
        return ''
      }
      return value.replace(/(<([^>]+)>)/gi, '')
    }    

    // Use a regular expression to match words
    const words = stripHtml(str).match(/\b(\w+(?:[&.']\w+)*)\b/g);

    // Check if there are at least three words
    if (words && words.length >= 3) {
        // Return the first three words joined by a space
        return words.slice(0, 3).join(' ');
    } else {
        // Return the original string if it has less than three words
        return str;
    }
  }  

  if (mz.context.filterShow) {
    // placeholder
  }
  function feraRefresh() {
    fera.forceRefreshContent()
  }
  function afterUpdate() {
    setTimeout(feraRefresh, 200)
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
